import { render, staticRenderFns } from "./ClearCart.vue?vue&type=template&id=3d26d52a"
import script from "./ClearCart.vue?vue&type=script&lang=js"
export * from "./ClearCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports